export function registerMenu($wrapper, $menu) {
  $(document).click(e => {
    // if the target of the click isn't the container nor a descendant of the container
    if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
      $menu.removeClass('d-block').addClass('d-none');
    }
  });
}
